import Vue from 'vue';
import Router from 'vue-router';

import LoginPage from '@/views/login-page/login-page.vue';
import HomePage from '@/views/home-page/home-page.vue';
import DashboardPage from '@/views/dashboard-page/dashboard-page.vue';
import NotFound from '@/views/not-found/not-found.vue';

import AppList from '@/components/app-list/app-list.vue';
import AppManage from '@/components/app-manage/app-manage.vue';

import CustomObject from '@/components/custom-object/custom-object.vue';
import CustomObjectAbout from '@/components/custom-object-about/custom-object-about.vue';
import CustomObjectEdit from '@/components/custom-object-edit/custom-object-edit.vue';
import CustomObjectSidebar from '@/components/custom-object-sidebar/custom-object-sidebar.vue';
import CustomObjectAddField from '@/components/custom-object-add-field/custom-object-add-field.vue';
import CustomObjectAddRelationship from '@/components/custom-object-add-relationship/custom-object-add-relationship.vue';

import ScriptPack from '@/components/script-pack/script-pack.vue';
import ScriptPackAbout from '@/components/script-pack-about/script-pack-about.vue';
import ScriptPackEdit from '@/components/script-pack-edit/script-pack-edit.vue';
import ScriptPackSidebar from '@/components/script-pack-sidebar/script-pack-sidebar.vue';
import ScriptPackAddScript from '@/components/script-pack-add-script/script-pack-add-script.vue';

import PanelItem from '@/components/panel-item/panel-item.vue';
import PanelItemAbout from '@/components/panel-item-about/panel-item-about.vue';
import PanelItemEdit from '@/components/panel-item-edit/panel-item-edit.vue';
import PanelItemSidebar from '@/components/panel-item-sidebar/panel-item-sidebar.vue';

import SiteApps from '@/components/site-apps/site-apps.vue';
import SiteList from '@/components/site-list/site-list.vue';

import routeGuard from '@/utils/route-guard';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginPage,
    },

    {
      path: '/',
      component: HomePage,
      beforeEnter: routeGuard.beforeEnter,
      children: [
        {
          path: '/',
          name: 'dashboard',
          component: DashboardPage,
          beforeEnter: routeGuard.beforeEnter,
          children: [
            {
              path: 'apps',
              name: 'apps',
              component: AppList,
            },
            {
              path: 'sites',
              name: 'sites',
              component: SiteList,
            },
          ],
        },

        {
          path: 'apps/:appName',
          props: true,
          component: AppManage,
          beforeEnter: routeGuard.beforeEnter,
          children: [

            {
              path: 'custom-object',
              name: 'custom-object-new',
              props: true,
              component: CustomObjectAbout,
            },
            {
              path: 'custom-object/:itemName/',
              component: CustomObject,
              children: [
                {
                  path: 'details',
                  name: 'custom-object-edit',
                  components: {
                    default: CustomObjectEdit,
                    sidebar: CustomObjectSidebar,
                  },
                },
                {
                  path: 'add-field',
                  name: 'add-field',
                  components: {
                    default: CustomObjectAddField,
                    sidebar: CustomObjectSidebar,
                  },
                },
                {
                  path: 'add-relationship',
                  name: 'add-relationship',
                  components: {
                    default: CustomObjectAddRelationship,
                    sidebar: CustomObjectSidebar,
                  },
                },
              ],
            },

            {
              path: 'script-pack',
              name: 'script-pack-new',
              props: true,
              component: ScriptPackAbout,
            },
            {
              path: 'script-pack/:itemName/',
              component: ScriptPack,
              children: [
                {
                  path: 'details',
                  name: 'script-pack-edit',
                  components: {
                    default: ScriptPackEdit,
                    sidebar: ScriptPackSidebar,
                  },
                },
                {
                  path: 'add-script',
                  name: 'add-script',
                  components: {
                    default: ScriptPackAddScript,
                    sidebar: ScriptPackSidebar,
                  },
                },
              ],
            },

            {
              path: 'panel-item',
              name: 'panel-item-new',
              props: true,
              component: PanelItemAbout,
            },
            {
              path: 'panel-item/:itemName/',
              component: PanelItem,
              children: [
                {
                  path: 'details',
                  name: 'panel-item-edit',
                  components: {
                    default: PanelItemEdit,
                    sidebar: PanelItemSidebar,
                  },
                },
              ],
            },

          ],
        },

        {
          path: 'sites/:siteName/manage-apps',
          name: 'manage-apps',
          props: true,
          component: SiteApps,
          beforeEnter: routeGuard.beforeEnter,
        },
      ],
    },
    {
      path: '*',
      component: NotFound,
    },
  ],
});
